const URL = {
  network: {
    membershipsIndex: 'memberships_path',
    membershipsAdvancedDonationsIndex:
      'backoffice_network_memberships_advanced_donations_path',
    updateHeadlineMembershipsAdvancedDonationsIndex:
      'update_headline_backoffice_network_memberships_advanced_donations_path',
    membershipsAdvancedDonations:
      'backoffice_network_memberships_advanced_donations_path',
    membershipsAdvancedDonation:
      'backoffice_network_memberships_advanced_donation_path',
    membershipsAdvancedAddonsIndex:
      'backoffice_network_memberships_advanced_addons_path',
    updateHeadlineMembershipsAdvancedAddonsIndex:
      'update_headline_backoffice_network_memberships_advanced_addons_path',
    membershipsAdvancedAddons:
      'backoffice_network_memberships_advanced_addons_path',
    membershipsAdvancedAddon:
      'backoffice_network_memberships_advanced_addon_path',
    membershipsAdvancedAddonUpdateImages:
      'backoffice_network_memberships_advanced_addon_update_images_path',
    membershipsAdvancedSelected:
      'edit_backoffice_network_memberships_type_path',
    membershipsSubscriptionExports:
      'backoffice_network_memberships_exports_path',
    membershipsSubscriptionExport: 'backoffice_network_memberships_export_path',
    membershipsOrderExports:
      'backoffice_network_memberships_orders_exports_path',
    membershipsOrderExport: 'backoffice_network_memberships_orders_export_path',
    event: 'event_path',
  },
  topic: {
    membershipsIndex: 'topic_memberships_index_path',
    membershipsAdvancedDonationsIndex:
      'backoffice_network_topic_memberships_advanced_donations_path',
    updateHeadlineMembershipsAdvancedDonationsIndex:
      'update_headline_backoffice_network_topic_memberships_advanced_donations_path',
    membershipsAdvancedDonations:
      'backoffice_network_topic_memberships_advanced_donations_path',
    membershipsAdvancedDonation:
      'backoffice_network_topic_memberships_advanced_donation_path',
    membershipsAdvancedAddonsIndex:
      'backoffice_network_topic_memberships_advanced_addons_path',
    updateHeadlineMembershipsAdvancedAddonsIndex:
      'update_headline_backoffice_network_topic_memberships_advanced_addons_path',
    membershipsAdvancedAddons:
      'backoffice_network_topic_memberships_advanced_addons_path',
    membershipsAdvancedAddon:
      'backoffice_network_topic_memberships_advanced_addon_path',
    membershipsAdvancedAddonUpdateImages:
      'backoffice_network_topic_memberships_advanced_addon_update_images_path',
    membershipsAdvancedSelected:
      'edit_backoffice_network_topic_membership_path',
    membershipsSubscriptionExports:
      'backoffice_network_topic_memberships_exports_path',
    membershipsSubscriptionExport:
      'backoffice_network_topic_memberships_export_path',
    membershipsOrderExports:
      'backoffice_network_topic_memberships_orders_exports_path',
    membershipsOrderExport:
      'backoffice_network_topic_memberships_orders_export_path',
    event: 'topic_event_path',
  },
};

export const polymorphicTopicUrl = (action, { isTopic = false, urlParams }) => {
  let url;

  if (isTopic !== undefined && isTopic !== null && isTopic !== false) {
    url = URL.topic;
  } else {
    url = URL.network;
  }

  return Routes[url[action]](...urlParams.filter(Boolean));
};
